import { useContext } from "react";
import { Panel } from "@radarly/models/panel";
import { Action } from "../action";
import ChannelContext from "../context";

export function useOpenPanel() {
  const { dispatch } = useContext(ChannelContext);
  return (panel: Panel) => {
    dispatch(Action.panelOpened(panel));
  };
}
